import { Component } from '@angular/core';

@Component({
  selector: 'ui-panel',
  templateUrl: './panel.component.html'
})
export class PanelComponent {

}